export default __webpack_public_path__ + "static/media/SEA_8367.3f2ddba3.jpg";